<template>
    <div>
        <button class="btn btn-primary m-2" @click.prevent="openCreateModal(null)">Agregar</button>

        <!-- Tabs -->
        <div class="tabs">
            <input id="tab1" v-model="activeTab" type="radio" name="tab-control" value="tab1">
            <input id="tab2" v-model="activeTab" type="radio" name="tab-control" value="tab2">
            <ul>
                <li><label :class="{ active: activeTab === 'tab1' }" for="tab1">Totales</label></li>
                <li><label :class="{ active: activeTab === 'tab2' }" for="tab2">Movimientos</label></li>
            </ul>
            <div class="slider"></div>
            <div class="content">
                <!-- Tab 1: Totales -->
                <section v-show="activeTab === 'tab1'">
                    <div class="table-container">
                        <table class="minimalist-table">
                            <thead>
                                <tr>
                                    <th>Método de Pago</th>
                                    <th v-for="option in typeOptions" :key="option.value">{{ option.text }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(method, methodKey) in paymentMethods" :key="methodKey">
                                    <td class="center-text">{{ method }}</td>
                                    <td v-for="option in typeOptions" :key="option.value" class="center-text">
                                        <span v-if="option.value === 'total-difference-percentage'">
                                            <span
                                                :class="{ 'text-danger': filteredPayments[methodKey]?.[option.value] > 0, 'text-success': filteredPayments[methodKey]?.[option.value] === 0 }">
                                                {{ formatPercentage(filteredPayments[methodKey]?.[option.value]) }}
                                                <span v-if="filteredPayments[methodKey]?.[option.value] > 0">🔴</span>
                                                <span
                                                    v-else-if="filteredPayments[methodKey]?.[option.value] === 0">🟢</span>
                                            </span>
                                        </span>
                                        <span v-else>
                                            {{ formatCurrency(filteredPayments[methodKey]?.[option.value]) }}
                                        </span>
                                    </td>
                                </tr>
                                <!-- Fila de Totales -->
                                <tr>
                                    <td class="center-text"><strong>Total</strong></td>
                                    <td v-for="option in typeOptions" :key="option.value" class="center-text">
                                        <strong>
                                            <span v-if="option.value === 'total-difference-percentage'">
                                                <span
                                                    :class="{ 'text-danger': filteredPayments.TOTAL?.[option.value] > 0, 'text-success': filteredPayments.TOTAL?.[option.value] === 0 }">
                                                    {{ formatPercentage(filteredPayments.TOTAL?.[option.value]) }}
                                                    <span v-if="filteredPayments.TOTAL?.[option.value] > 0">🔴</span>
                                                    <span
                                                        v-else-if="filteredPayments.TOTAL?.[option.value] === 0">🟢</span>
                                                </span>
                                            </span>
                                            <span v-else>
                                                {{ formatCurrency(filteredPayments.TOTAL?.[option.value]) }}
                                            </span>
                                        </strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
                <!-- Tab 2: Movimientos -->
                <section v-show="activeTab === 'tab2'">
                    <div class="table-container">
                        <table class="minimalist-table">
                            <thead>
                                <tr>
                                    <th>Usuario</th>
                                    <th>Movimiento</th>
                                    <th>Tipo de Pago</th>
                                    <th>Cantidad</th>
                                    <th>Comentarios</th>
                                    <th class="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in filteredItems.data" :key="item.id">
                                    <td class="center-text">{{ item.user.name }}</td>
                                    <td class="center-text">{{typeOptions.find(option => option.value ===
                                        item.type)?.text}}</td>
                                    <td class="center-text">{{ item.payment.name }}</td>
                                    <td class="center-text">{{ formatCurrency(item.amount) }}</td>
                                    <td class="center-text">{{ item.comments }}</td>
                                    <td class="center-text">
                                        <button class="btn btn-link p-0 px-2 pt-2" @click.prevent="openEditModal(item)">
                                            <i class="fa-duotone fa-solid fa-pen-to-square"></i>
                                        </button>
                                        <button
class="btn btn-link p-0 px-1 pt-2"
                                            @click.prevent="Delete(item, item.amount, 'movimiento de caja')">
                                            <i class="fa-duotone fa-solid fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </div>

        <Pagination
class="mt-3" :total-items="totalItems" :current-page="currentPage" :last-page="lastPage"
            :items-per-page="itemsPerPage" @page-change="changePage" />
        <Modal v-if="openModal" v-model="openModal" :is-edit-mode="isEditMode" @submit-entity="handleEntity">
            <template #default="">
                <div class="row">
                    <div class="col-md-4 mb-3">
                        <label for="localType" class="form-label">Fecha</label>
                        <DatePicker
id="localCreated" v-model="localCreated" class="form-control" :errors="fieldErrors"
                            error-field-name="created" />
                    </div>
                    <div class="col-md-4 mb-3">
                        <label for="localType" class="form-label">Tipo</label>
                        <select id="localType" v-model="localType" class="form-control">
                            <option v-for="option in typeOptions" :key="option.value" :value="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                        <div v-if="fieldErrors.type" class="invalid-feedback">
                            {{ fieldErrors.type[0] }}
                        </div>
                    </div>
                    <div class="col-md-4 mb-3">
                        <div :class="{ 'is-invalid': fieldErrors.payment_type }">
                            <MenuSelectedFull
v-model="localPaymentType" label="Forma de pago" apiurl="payment-methods"
                                :can-edit-and-add="false" />
                        </div>
                        <div v-if="fieldErrors.payment_type" class="invalid-feedback">
                            {{ fieldErrors.payment_type[0] }}
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="localAmount" class="form-label">Cantidad</label>
                    <input id="localAmount" v-model="localAmount" type="text" class="form-control" />
                    <div v-if="fieldErrors.amount" class="invalid-feedback">
                        {{ fieldErrors.amount[0] }}
                    </div>
                </div>
                <div class="mb-3">
                    <label for="localComment" class="form-label">Comentario</label>
                    <input id="localComment" v-model="localComment" type="text" class="form-control" />
                    <div v-if="fieldErrors.comments" class="invalid-feedback">
                        {{ fieldErrors.comments[0] }}
                    </div>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script setup>
import {
    ref,
    getCurrentInstance,
    watch,
    onMounted,
    defineProps,
    computed
} from "vue";
import Pagination from "@/components/Pagination.vue";
import { useActions } from "@/composables/useActions";
import Modal from "@/components/Modal.vue";
import MenuSelectedFull from "@/components/MenuSelectedFull.vue";
import DatePicker from '@/components/DatePicker.vue'

const { proxy } = getCurrentInstance();
const resourceApi = "sales-box-details";

const {
    currentPage,
    itemsPerPage,
    lastPage,
    filteredItems,
    totalItems,
    changePage,
    fetchItems,
    updateShowDeleted,
    addModel,
    editModel,
    confirmDelete,
    setAdditionalParams,
    fieldErrors,
    message
} = useActions(resourceApi);

itemsPerPage.value = 50;

const openModal = ref(false);
const isEditMode = ref(true);
const selectedItem = ref(null);
const localType = ref("open");
const localPaymentType = ref("");
const localAmount = ref(0);
const localComment = ref("");
const localCreated = ref("");
const errors = ref({});
const activeTab = ref('tab1');

const paymentMethods = {
    Cash: "Efectivo",
    CreditCard: "Tarjeta de crédito",
    DebitCard: "Tarjeta de débito",
    BankTransfer: "Transferencia bancaria",
    PayPal: "PayPal",
    Check: "Cheque",
};

// Columnas de la tabla (movimientos y totales)
const typeOptions = [
    { value: "open", text: "Apertura" },
    { value: "break", text: "Corte" },
    { value: "spent", text: "Gasto" },
    { value: "income", text: "Ingreso" },
    { value: "close", text: "Cierre" },
    { value: "income-pos", text: "Ingresos (Ventas POS)" },
    { value: "box-movements", text: "Total Movimientos" },
    { value: "total-expected-balance", text: "Saldo Esperado" },
    { value: "total-balance-actual", text: "Diferencia (Saldo vs Real)" },
    { value: "total-difference-percentage", text: "DIF. %" },
];

const filteredPayments = computed(() => {
    if (!filteredItems.value || !filteredItems.value.summed_payments) {
        console.log("No hay summed_payments, devolviendo objeto vacío");
        return {}; // Devolver un objeto vacío si no hay datos
    }

    console.log("summed_payments:", filteredItems.value.summed_payments);

    // Convertir el array de summed_payments a un objeto con claves de payment_method
    const paymentsObject = filteredItems.value.summed_payments.reduce((acc, payment) => {
        if (payment.payment_method) {
            acc[payment.payment_method] = payment;
        } else {
            console.warn("Método de pago no definido en:", payment);
        }
        return acc;
    }, {});

    console.log("Objeto generado en computed:", paymentsObject);
    return paymentsObject;
});

const openCreateModal = async () => {
    isEditMode.value = false;
    localType.value = "open";
    localPaymentType.value = "";
    localAmount.value = 0.00;
    localComment.value = "";
    localCreated.value = new Date().toISOString().split('T')[0];
    errors.value = {};
    openModal.value = true;
};

const openEditModal = (item) => {
    isEditMode.value = true;
    selectedItem.value = { ...item };
    localType.value = item.type;
    localPaymentType.value = item.payment_type;
    localAmount.value = item.amount;
    localComment.value = item.comments;
    localCreated.value = item.created;
    errors.value = {}; // Resetea los errores
    openModal.value = true;
};

const formatCurrency = (value) => {
    if (isNaN(value) || value === undefined || value === null) {
        return "$0.00";
    }
    return parseFloat(value).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
    }).replace("$", "$ ");
};

// Función para formatear porcentaje
const formatPercentage = (value) => {
    if (isNaN(value) || value === undefined || value === null) {
        return "0%";
    }
    return `${parseFloat(value).toFixed(1)}%`;
};

watch([itemsPerPage, currentPage], ([newItemsPerPage, newPage]) => {
    if (newItemsPerPage || newPage) {
        fetchItems(newPage);
    }
});

onMounted(async () => {
    await fetchItems();
    updateShowDeleted(false);
    setAdditionalParams({ salesbox_id: props.data.id });
});

const props = defineProps({
    data: Object,
    formData: Object,
});

const Delete = async (item, name, entity) => {
    await confirmDelete(item, name, entity);
    fetchItems();
};

const handleEntity = async () => {
    const boxData = {
        salesbox_id: props.data.id,
        type: localType.value,
        payment_type: localPaymentType.value,
        amount: localAmount.value,
        comments: localComment.value,
        created: localCreated.value,
    };

    errors.value = {}; // Resetear errores antes de la petición

    try {
        let response;

        if (isEditMode.value) {
            response = await editModel({
                id: selectedItem.value.id,
                ...boxData
            });
        } else {
            response = await addModel(boxData);
        }

        if (response && (response.status === 200 || response.status === 201)) {
            proxy.$notify(message.value, "", "success", "ni ni-like-2 ni-lg");
            openModal.value = false;
            fetchItems();
        }
    } catch (err) {
        if (err.response && err.response.status === 422) {
            errors.value = err.response.data.errors || {};
            console.log("Errores capturados:", errors.value);
            openModal.value = true;
        } else {
            proxy.$notify("Ocurrió un error inesperado.", "", "danger", "ni ni-like-2 ni-lg");
        }
    }
};
</script>

<style scoped>
/* Contenedor de la tabla */
.table-container {
    margin-top: 1rem;
    overflow-x: auto;
}

/* Estilo general de la tabla */
.minimalist-table {
    width: 100%;
    border-collapse: collapse;
    font-family: "Inter", sans-serif;
    font-size: 0.9rem;
}

/* Encabezados de la tabla */
.minimalist-table th {
    background-color: #f8f9fa;
    color: #6c757d;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    padding: 12px;
    text-align: center;
}

/* Filas y celdas */
.minimalist-table td {
    padding: 14px 10px;
    border-bottom: 1px solid #e0e0e0;
    vertical-align: middle;
    /* Asegura alineación vertical correcta */
}

/* Asegurar que la primera columna (Nombre) esté alineada a la izquierda */
.minimalist-table td:first-child {
    text-align: left;
    padding-left: 16px;
}

/* Alternar colores en filas */
.minimalist-table tr:nth-child(even) {
    background-color: #fdfdfd;
}

.minimalist-table tr:hover {
    background-color: #f4f6f8;
}

/* Centrar el texto en las columnas de cantidad, descuento, IVA y total */
.center-text {
    text-align: center;
    font-weight: bold;
    color: #343a40;
}

/* Descripción del producto */
.description {
    font-size: 0.85rem;
    color: #6c757d;
    margin-top: 4px;
}

/* Asegurar que la celda de acciones ocupe la altura total de la fila */
.minimalist-table td:last-child {
    height: 100%;
    vertical-align: middle;
    /* Evita que el contenido se desplace hacia arriba */
    padding: 0;
    /* Elimina padding extra */
}

/* Estilos de los botones */
.btn-group button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    /* Elimina cualquier padding extra */
    margin: 0;
    /* Elimina cualquier margen extra */
    height: 100%;
    /* Asegura que el botón ocupe toda la celda */
}

/* Estilos de los iconos */
.btn-group i {
    font-size: 1.2rem;
    color: #6c757d;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

/* Hover en los iconos */
.icon-edit:hover {
    color: #007bff;
    transform: scale(1.1);
}

.icon-delete:hover {
    color: #dc3545;
    transform: scale(1.1);
}

/* Evitar que el borde inferior de la fila se corte */
.minimalist-table tr:last-child td {
    border-bottom: none;
}

.refund-row {
    background-color: #ffcccc;
    border-radius: 4px;
}

.refund-notice-color {
    color: #ffcccc;
}

.refund-notice {
    padding-top: 0px;
    border-radius: 5px;
    text-align: left;
    color: #333;
    display: flex;
    align-items: center;
    height: 40px;
    font-size: .80rem;
}

.fixed-footer .form-control {
    flex: 1 1 100%;
}

/* Estilos para las pestañas */
.tabs {
    position: relative;
    margin: 2rem 0;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.tabs ul {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    border-bottom: 3px solid #007bff;
    justify-content: space-around;
}

.tabs ul li {
    flex: 1;
    text-align: center;
}

.tabs ul li label {
    display: block;
    margin: 0;
    padding: 1rem;
    cursor: pointer;
    transition: background 0.3s ease, color 0.3s ease;
    font-weight: bold;
    border-radius: 8px 8px 0 0;
}

.tabs ul li label:hover {
    background: rgba(0, 123, 255, 0.1);
    color: #007bff;
}

.tabs ul li label.active {
    background: #007bff;
    color: white;
}

.tabs .slider {
    position: absolute;
    bottom: 0;
    width: 50%;
    height: 5px;
    background: #007bff;
    border-radius: 5px;
    transition: transform 0.3s ease;
}

.tabs .content {
    padding: 2rem;
    background: white;
    border-radius: 12px;
    box-shadow: none;
    animation: fadeIn 0.5s ease-in-out;
}

.tabs .content section {
    display: none;
}

.tabs input:nth-of-type(1):checked~.slider {
    transform: translateX(0%);
}

.tabs input:nth-of-type(2):checked~.slider {
    transform: translateX(100%);
}

.tabs input:nth-of-type(1):checked~.content section:nth-of-type(1) {
    display: block;
}

.tabs input:nth-of-type(2):checked~.content section:nth-of-type(2) {
    display: block;
}

.tabs input {
    position: absolute;
    opacity: 0;
    visibility: hidden;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>